module.exports = __webpack_public_path__ + "img/creditcard_security2.2a0c158e.svg";